import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../service/common/notification/notification.service';
import { ConfirmDialogService } from '../../service/common/confirm-dialog/confirm-dialog.service';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { take } from 'rxjs/operators';
import { SchaltleitungService } from '../../service/schaltleitung/schaltleitung.service';
import { Schaltleitung } from '../../domain/model/schaltleitung';
import { KontaktItem } from '../../domain/model/kontakt-item';

@Component({
    selector: 'tnb-settings-schaltleitung-detail',
    templateUrl: './settings-schaltleitung-detail.component.html',
    styleUrls: [
        './settings-schaltleitung-detail.component.scss',
    ],
    standalone: false,
})
export class SettingsSchaltleitungDetailComponent implements OnInit {
    private schaltleitungService = inject(SchaltleitungService);
    private activatedRoute = inject(ActivatedRoute);
    private notificationService = inject(NotificationService);
    private confirmDialogService = inject(ConfirmDialogService);
    private changeDetectorRef = inject(ChangeDetectorRef);
    westnetzSidenavService = inject(WestnetzSidenavService);

    public schaltleitung: Schaltleitung = new Schaltleitung();
    public createNew: boolean = false;

    ngOnInit() {
        const schaltleitungId = this.activatedRoute.snapshot.queryParams['schaltleitung'];
        this.createNew = schaltleitungId == null || schaltleitungId === '';
        if (schaltleitungId) {
            this.schaltleitungService.getSchaltleitung(schaltleitungId)
                .pipe(take(1))
                .subscribe((schaltleitung: Schaltleitung) => {
                    this.schaltleitung = schaltleitung;
                    this.changeDetectorRef.markForCheck();
                });
        }
    }

    saveSchaltleitung() {
        // clean up KontaktItems
        const cleanedUpKontakte: KontaktItem[] = [];
        this.schaltleitung.kontakte.forEach((ki) => {
            if ((ki.data && ki.data.trim().length > 0) || (ki.type && ki.type.trim().length > 0)) {
                cleanedUpKontakte.push(ki);
            }
        });
        this.schaltleitung.kontakte = cleanedUpKontakte;

        if (this.createNew) {
            this.schaltleitungService.createSchaltleitung(this.schaltleitung).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Die Schaltleitung wurde erfolgreich angelegt');
            });
        } else {
            this.schaltleitungService.saveSchaltleitung(this.schaltleitung).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Die Schaltleitung wurde erfolgreich gespeichert');
            });
        }
    }

    async deleteSchaltleitung(schaltleitung: Schaltleitung) {
        if (await this.confirmDialogService.confirm(
            'Beachten Sie, dass wenn Sie fortfahren, sowohl die Schaltleitung, als auch alle bestehenden Zuordnungen ' +
            'zu Netzbetreibern entfernt werden. Dieser Vorgang kann nicht rückgängig gemacht werden.',
            'Schaltleitung entfernen!',
            'warn',
            'Entfernen',
            'Abbrechen',
            'innogy_picto_bin_c-check',
        )) {
            this.schaltleitungService.deleteSchaltleitung(schaltleitung).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Die Schaltleitung wurde entfernt');
            });
        }
    }

    addKontakt() {
        this.schaltleitung.kontakte.push(new KontaktItem('', ''));
    }
}
